// generated by genversion
export const version = '3.5.4';
